<template>
  <div>
    <servico-cadastro-modal v-if="modalCadastrarServico" v-model="modalCadastrarServico"
                            @fecharModalCadastrarServico="fecharModalAdicionarServico"/>
    <servico-editar-modal v-if="modalEditarServico" v-model="modalEditarServico" :servico="servicoSelecionado"
                          @fecharModalEditarServico="fecharModalEditarServico"/>
    <v-dialog v-model="model" max-width="550" scrollable @click:outside="fecharModal">
      <v-card>
        <v-toolbar dark color="primary" elevation="0">
          <v-toolbar-title>{{ permiteSelecionar ? 'Selecionar serviço' : 'Gerenciar serviços' }}</v-toolbar-title>
          <v-spacer/>
          <v-btn class="close__button" text @click="fecharModal" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="row-bottom">
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" color="primary" depressed @click="adicionarServico">
                <v-icon>add</v-icon>
              </v-btn>
            </template>
            Adicionar serviço
          </v-tooltip>

          <pesquisa-avancada
              :filter="filtrosInterno"
              @remove-filter="tratarEventoRemoverFiltro"
              @simple-search="tratarEventoBuscaSimples"
              :maxlengthInput="maxInputPesquisa"
              simple-search-placeholder="Busque por titulo..."/>
        </div>
        <v-card-text class="container-list-servicos">
          <servicos-tabela
              :itens="itens"
              :paginas="paginas"
              :totalItens="totalItens"
              :paginacao="$store.state.servico.resultadoBuscaTodosServicos.paginacao"
              :permiteSelecionar="permiteSelecionar"
              @editarItem="tratarEventoAcessarServico"
              @selecionarItem="tratarEventoSelecionarServico"
          />
        </v-card-text>
        <div class="pl-2 pr-3">
          <div class="pagination">
            <v-pagination
                v-if="paginas > 1"
                v-model="paginacaoInterna.page"
                total-visible="7"
                :length="paginas"
                @input="tratarEventoPaginar"
            />
            <v-spacer v-if="paginas <= 1"/>
            <div class="select-pagination">
              <span>Linhas por página:</span>
              <v-select :items="linhasPorPagina" @change="resetarPaginacao" v-model="paginacaoInterna.size"/>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>

import _ from 'lodash'
import {mapMutations} from 'vuex'
import {actionTypes, mutationTypes} from '@/core/constants'
import PesquisaAvancada from '@/views/components/PesquisaAvancada.vue'
import ServicoCadastroModal from '@/views/modais/servicos/ServicoCadastroModal.vue'
import ServicosTabela from '@/views/modais/servicos/ServicosTabela.vue'
import ServicoEditarModal from '@/views/modais/servicos/ServicoEditarModal.vue'

export default {
    name: 'ServicosModal',
    components: {ServicoEditarModal, ServicosTabela, ServicoCadastroModal, PesquisaAvancada},
    props: {
        value: {
            type: Boolean,
            required: true
        },
        permiteSelecionar: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            filtrosInterno: this.getFiltros(),
            paginacaoInterna: this.getPaginacao(),
            itens: [],
            paginas: 0,
            totalItens: 0,
            linhasPorPagina: [10, 25, 50, 100],
            maxInputPesquisa: 30,
            servicoSelecionado: null,
            modalCadastrarServico: false,
            modalEditarServico: false
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    async mounted() {
        await this.buscar()
    },
    methods: {
        ...mapMutations([
            mutationTypes.SERVICO.SET_FILTROS_BUSCA_TODOS_SERVICOS,
            mutationTypes.SERVICO.SET_PAGINACAO_BUSCA_TODOS_SERVICOS
        ]),
        async buscarTodosServicos() {
            const resultado = await this.$store.dispatch(actionTypes.SERVICO.BUSCAR_TODOS_SERVICOS)
            if (resultado) {
                this.itens = resultado.items
                this.paginas = resultado.totalPages
                this.totalItens = resultado.totalElements
            }
        },
        async buscar() {
            this.setFiltrosBuscaTodosServicos(this.getFiltrosInterno())
            await this.buscarTodosServicos()
        },
        tratarEventoRemoverFiltro(propriedade) {
            if (this.filtrosInterno[propriedade]) {
                this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
            }
            this.buscar()
        },
        getFiltros() {
            return _.cloneDeep(this.$store.state.servico.resultadoBuscaTodosServicos.filtros)
        },
        getPaginacao() {
            return _.cloneDeep(this.$store.state.servico.resultadoBuscaTodosServicos.paginacao)
        },
        getFiltrosInterno() {
            return _.cloneDeep(this.filtrosInterno)
        },
        tratarEventoPaginar() {
            this.setPaginacaoBuscaTodosServicos(this.paginacaoInterna)
            this.buscar()
        },
        tratarEventoBuscaSimples(busca) {
            this.filtrosInterno.conteudo.value = busca
            this.resetarPaginacao()
        },
        fecharModal() {
            this.model = false
            this.$emit('fecharModalServicos')
        },
        adicionarServico() {
            this.modalCadastrarServico = true
        },
        fecharModalAdicionarServico() {
            this.modalCadastrarServico = false
            this.resetarPaginacao()
        },
        tratarEventoAcessarServico(item) {
            this.servicoSelecionado = item
            this.modalEditarServico = true
        },
        fecharModalEditarServico() {
            this.modalEditarServico = false
            this.servicoSelecionado = null
            this.resetarPaginacao()
        },
        resetarPaginacao() {
            this.$store.commit(mutationTypes.SERVICO.RESETA_PAGE)
            this.tratarEventoPaginar()
        },
        tratarEventoSelecionarServico(item) {
            this.$emit('selecionarServico', item)
        }
    }
}
</script>

<style scoped lang="stylus">

.row-bottom
  border-bottom-width 1px
  border-bottom-style solid
  border-bottom-color #ccc
  box-sizing border-box
  padding 10px 0 10px 10px
  display flex
  justify-content space-between


.container-list-servicos
  padding 0px !important
  height 300px

</style>